import { createLfpGame } from '../../../entities/lfpGame';

export const scope = 'LFP_GAME_CREATE';
export const RESET_CREATE_LFP_GAME = 'RESET_CREATE_LFP_GAME';

export function createLfpGameIfNeeded(payload) {
    return (dispatch, getState) => {
        const widget = getState().app.onSite.lfpGame.infoWidget;

        if (!widget.info.isPosting)
            dispatch(createLfpGame(payload, scope));
    };
}

export function resetCreateLfpGame() {
    return { type: RESET_CREATE_LFP_GAME, scope }
}



// WEBPACK FOOTER //
// ./src/actions/app/onSite/lfpGame/create.js